export function remainingShieldMs(until, clockOffsetMs = 0, nowMs = Date.now()) {
  if (!until) return 0;
  const end = new Date(until).getTime();
  if (!Number.isFinite(end)) return 0;
  return Math.max(0, end - (nowMs + (Number(clockOffsetMs) || 0)));
}

export function isCityProtected(until, clockOffsetMs = 0, nowMs = Date.now()) {
  return remainingShieldMs(until, clockOffsetMs, nowMs) > 0;
}

export function formatShieldCountdown(until, clockOffsetMs = 0, nowMs = Date.now()) {
  const total = Math.floor(
    remainingShieldMs(until, clockOffsetMs, nowMs) / 1000
  );
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const seconds = total % 60;
  const pad = (n) => String(n).padStart(2, "0");
  if (hours > 0) return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  return `${pad(minutes)}:${pad(seconds)}`;
}

export function shieldBadgeLabel(kind) {
  const isProd = process.env.NODE_ENV === "production";
  if (kind === "defeat") {
    return isProd ? "Defeat Recovery (12h)" : "Defeat Recovery (10m)";
  }
  return isProd ? "Victory Truce (6h)" : "Victory Truce (5m)";
}
